<template>
  <div v-bind:class="{ 'priority-modal-container': true, show: show }">
    <div class="geofence-priority-container">
      <div class="geofence-priority">
        <div v-bind:class="{ geofences: true, loading: loading }">
          <div class="title" v-show="!loading">Drag and drop to the items to sort.</div>
          <div class="row expanded">
            <draggable v-model="geofences">
              <div class="small-12 columns" v-for="(geofence, index) in geofences">
                <div class="geofence">
                  <span class="color" v-bind:style="{ backgroundColor: '#' + (geofence.overlayColor || geofence.color) }"></span>
                  <span class="name">{{ geofence.name }}</span>
                </div>
              </div>
            </draggable>
          </div>

          <div class="controls" v-show="!loading">
            <a href="javascript:;" class="button small cta secondary" @click="close">CANCEL</a>
            <a href="javascript:;" v-bind:class="{ 'button small cta success save-btn': true, disabled: saving }" @click="save">
              <i class="fa fa-spinner fa-spin" v-show="saving"></i>
              <span v-show="!saving">SAVE</span>
            </a>
          </div>

          <div class="loader" v-show="loading">
            <i class="fa fa-spinner fa-spin fa-lg"></i>
            <div>LOADING GEOFENCES...</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import draggable from 'vuedraggable'
export default {
  name: 'geofence-priority',
  components: { draggable },
  data () {
    return {
      loading: true,
      geofences: [],
      saving: false
    }
  },
  computed: {
    show () { return this.$store.state.geofences.priority.show },
    geofenceType () { return this.$store.state.geofences.filters.type },
    geofenceBrand () { return this.$store.state.geofences.filters.brands },
    useOldQuatation () { return CONFIG.useOldQuatation}
  },
  methods: {
    save () {
      let self = this
      let geofences = {}
      let indexStart = 0
      if (self.geofenceType === 'servicearea' && !self.useOldQuatation && self.geofenceBrand > 0) {
        indexStart = parseInt(self.geofenceBrand) * 1000
      }

      for (let i = 0; i < self.geofences.length; i++) {
        geofences[self.geofences[i].id] = i + indexStart
      }
      self.saving = true

      self.$sdk.post('/geofences/priority', {
        token: self.$store.state.session.sessionToken,
        geofences: geofences
      }, r => {
        self.saving = false
        self.close()
        if (r.error) {
          console.log('ERROR', r)
          return
        }
        self.$store.commit('geofences/setPrioritySuccess', true)
      })
    },
    close () { this.$store.commit('geofences/setShowGeofencePriority', false) },
    loadGeofences () {
      let self = this
      self.loading = true
      self.geofence = []

      let request = {
        token: self.$store.state.session.sessionToken,
        status: 'active',
        type: self.geofenceType,
        pageNum: 1,
        pageSize: -1,
        order: 'priority'
      }

      if (self.geofenceType === 'servicearea') {
        delete request.type
        request.brandId = self.geofenceBrand || -1
        request.pageSize = 9999
        self.$sdk.get('/servicearea', request, r => {
          self.loading = false
          if (r.error) {
            self.$store.commit('geofences/setShowGeofencePriority', false)
            return
          }
  
          self.geofences = r.list
        }, '2.0')
      } else {
        self.$sdk.get('/geofences/search', request, r => {
          self.loading = false
          if (r.error) {
            self.$store.commit('geofences/setShowGeofencePriority', false)
            return
          }
  
          self.geofences = r.list
        })
      }
    }
  },
  watch: {
    show (value) {
      let self = this
      self.saving = false
      if (!value) {
        self.loading = false
        self.geofences = []
        return
      }

      self.loadGeofences()
    }
  }
}
</script>

<style lang="scss" scoped>
.priority-modal-container {
  position: fixed;
  top: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 12;
  opacity: 0;
  background-color: rgba(0,0,0,0.7);
  transition: all 250ms;
  overflow: auto;

  &.show {
    top: 0;
    opacity: 1;
  }
}

.geofence-priority-container {
  display: table;
  width: 100%;
  height: 100%;
}

.geofence-priority {
  display: table-cell;
  vertical-align: middle;
  padding: 30px;
  position: relative;

  & .title {
    padding: 20px 0 30px;
    text-align: center;
    font-weight: 700;
    font-size: 18px;
    color: #0D79F2;
  }
}

.geofences {
  padding: 0 30px 30px;
  position: relative;
  background-color: #fff;
  margin: 30px;
  min-height: 300px;
  transition: all 250ms;
  width: 500px;
  margin: 0 auto;

  &.loading {
    min-height: 100px;
    width: 300px;
    margin: 0 auto;
  }
}

.geofence {
  padding: 10px;
  border: 1px solid rgba(0,0,0,0.3);
  margin: 0 7px 10px;
  border-radius: 3px;
  font-size: 14px;
  cursor: pointer;

  & span {
    display: inline-block;
    vertical-align: middle;
  }
  & .color {
    width: 13px;
    height: 13px;
    border: 1px solid rgba(0,0,0,0.2);
    border-radius: 3px;
    margin-right: 10px;
  }
}

.controls {
  text-align: center;
  margin-top: 30px;
}

.loader {
  text-align: center;
  padding: 30px 0 0;
}

.save-btn { width: 83px; }

@media only screen and (max-width: 430px) {
  .geofence-priority {
    padding: 0;
    .geofences {
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Geofences/GeofencePriority.vue